import { ScrollableCurriculumTabStrip } from "@/components/ui/scrollable-curriculum-tab-strip";
import { Tabs, TabsContent, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
import { BeltRank } from "../../MembersArea";

const DEFAULT_TAB_SURFACE = "!bg-gray-200 !text-gray-900";

interface JitaeProps {
  selectedBelt: BeltRank;
  getBeltColor: (belt: BeltRank) => string;
  hasDemo?: (aliases: string[]) => boolean;
  onWatchDemo?: (aliases: string[]) => void;
  presentation?: "legacy" | "curriculum";
  beltTabSurfaceClass?: string;
}

function JitaeMovesOl() {
  return (
    <ol className="list-none space-y-2">
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">First:</span>
                      <span className="text-gray-700">First to the Left (Da direction)</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">Ready:</span>
                      <span className="text-gray-700">Begin from Ready Stance (joon-bee).</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">1.</span>
                      <span className="text-gray-700">Step with the left foot into Right Back Stance (i.e., left foot forward) and execute a Left Outward Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">2a.</span>
                      <span className="text-gray-700">Slowly step forward with the right foot into Right Front Stance and slowly and powerfully execute a Right High Block (i.e., upward block).</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">2b.</span>
                      <span className="text-gray-700">Without stepping, slowly and powerfully pull the opponent with the right hand while executing a Left Punch.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">3.</span>
                      <span className="text-gray-700">Then to the Right (Ra direction)</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">4.</span>
                      <span className="text-gray-700">Step with the right foot to turn 180 clockwise into Left Back Stance (i.e., right foot forward) and execute a Right Outward Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">5a.</span>
                      <span className="text-gray-700">Slowly step forward with the left foot into Left Front Stance and slowly and powerfully execute a Left High Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">5b.</span>
                      <span className="text-gray-700">Without stepping, slowly and powerfully pull the opponent with the left hand while executing a Right Punch.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">6.</span>
                      <span className="text-gray-700">Up the Middle (Ga direction)</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">7.</span>
                      <span className="text-gray-700">Step with the left foot to turn 90 counterclockwise into Left Front Stance and execute a Left Low Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">8.</span>
                      <span className="text-gray-700">Without pausing, slide the left foot back into Right Back Stance (i.e., left foot forward) and execute a single Knifehand High Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">9a.</span>
                      <span className="text-gray-700">With the left foot fixed, execute a Right Front Kick.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">9b.</span>
                      <span className="text-gray-700">Set the right foot down in Left Back Stance (i.e., right foot forward) and execute a Double Knifehand Low Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">10.</span>
                      <span className="text-gray-700">Without stepping, slowly and powerfully execute an Outward Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">11a.</span>
                      <span className="text-gray-700">With the right foot fixed, execute a Left Front Kick.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">11b.</span>
                      <span className="text-gray-700">Set the left foot down in Right Back Stance (i.e., left foot forward) and execute a Double Knifehand Low Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">12.</span>
                      <span className="text-gray-700">Slide the left foot back into Left Front Stance and slowly execute a High Block</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">13a.</span>
                      <span className="text-gray-700">Stepping forward with the right foot, lower the left arm to prepare for a Diamond Punch</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">13b.</span>
                      <span className="text-gray-700">Complete the step forward into Right Front Stance and execute a Diamond Punch.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">14a.</span>
                      <span className="text-gray-700">Without stepping, execute a Left Inward Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">14b.</span>
                      <span className="text-gray-700">Without stepping, quickly execute a Right Augmented Inward Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">15.</span>
                      <span className="text-gray-700">Step back with the right foot into Right Back Stance (i.e., left foot forward) and execute a Left Knifehand Low Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">16a.</span>
                      <span className="text-gray-700">With the left foot fixed, execute a Right Front Kick.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">16b-c.</span>
                      <span className="text-gray-700">Set the right foot down to the rear into Left Front Stance) and execute a Double Punch, punching first with the right hand and then with the left hand.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">17.</span>
                      <span className="text-gray-700">At the Top</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">18.</span>
                      <span className="text-gray-700">Pivoting 180 counterclockwise move the left foot into Horse-riding Stance and execute a Bull Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">19.</span>
                      <span className="text-gray-700">Without stepping, execute a Left Low Side Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">20.</span>
                      <span className="text-gray-700">Without stepping, turn the upper body 180 to the right and execute a Right Knifehand Side Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">21.</span>
                      <span className="text-gray-700">Without stepping, execute a Left Hammerfist Target Strike. Kihap.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">22.</span>
                      <span className="text-gray-700">Lift the right leg into Left Crane Stance and execute a Right Low Side Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">23a.</span>
                      <span className="text-gray-700">Without stepping, execute a Small Hinge Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">23b.</span>
                      <span className="text-gray-700">Pivoting on the left foot, execute a Right Side Kick.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">24.</span>
                      <span className="text-gray-700">Set the right foot down beside the left foot, then lift the left leg into Right Crane Stance and execute a Left Low Side Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">25.</span>
                      <span className="text-gray-700">Without stepping, execute a Small Hinge Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">26a.</span>
                      <span className="text-gray-700">Pivoting on the right foot, execute a Left Side Kick.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">26b.</span>
                      <span className="text-gray-700">Then Back to Start (Na direction)</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">27.</span>
                      <span className="text-gray-700">Set the left foot down in Left Front Stance and execute a Right Punch.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">28.</span>
                      <span className="text-gray-700">Step forward with the right foot into Right Front Stance and execute a Right Punch. Kihap.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">29.</span>
                      <span className="text-gray-700">Pivoting 270 counterclockwise, move the left foot into Right Back Stance (i.e., left foot forward) and execute a Double Knifehand Low Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">30.</span>
                      <span className="text-gray-700">Step forward with the right foot into Left Back Stance (i.e., right foot forward) and execute a Double Knifehand Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">31.</span>
                      <span className="text-gray-700">Pivoting 180 clockwise, move the right foot into Left Back Stance (i.e., right foot forward) and execute a Double Knifehand Low Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">32.</span>
                      <span className="text-gray-700">Step forward with the left foot into Right Back Stance and execute a Double Knifehand Block.</span>
                    </li>
                <li className="flex">
                  <span className="mr-2 text-taekwondo-red">End:</span>
                  <span className="text-gray-700">Moving the left foot, return to Ready Stance.</span>
                </li>
              </ol>

  );
}

export default function Jitae({
  selectedBelt,
  getBeltColor: _getBeltColor,
  hasDemo,
  onWatchDemo,
  presentation = "legacy",
  beltTabSurfaceClass = DEFAULT_TAB_SURFACE,
}: JitaeProps) {
  if (!["BLACK/D5"].includes(selectedBelt)) {
    return null;
  }

  const surface = beltTabSurfaceClass;
  const triggerClass = cn(
    "inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-black/10 px-3 py-2 text-xs font-medium md:text-sm",
    surface,
    "data-[state=active]:z-10 data-[state=active]:shadow-md data-[state=active]:ring-2 data-[state=active]:ring-gray-900/40 data-[state=active]:ring-offset-2 data-[state=active]:ring-offset-gray-100",
  );

  const demoBtn =
    hasDemo?.(["jitae"]) ? (
      <button
        type="button"
        className="inline-flex items-center text-sm font-medium text-taekwondo-blue hover:underline"
        onClick={() => onWatchDemo?.(["jitae"])}
      >
        Watch Demonstration Video
      </button>
    ) : null;

  if (presentation === "curriculum") {
    return (
      <div className="rounded-lg bg-gray-50 p-4 md:p-5">
        <h2 className="mb-2 text-lg font-semibold text-taekwondo-red md:text-xl">Jitae</h2>
        {demoBtn && <div className="mb-3">{demoBtn}</div>}
        <Tabs defaultValue="pattern-information" className="w-full space-y-4">
          <ScrollableCurriculumTabStrip ariaLabelPrefix="Jitae">
            <TabsTrigger value="pattern-information" className={triggerClass}>
              Pattern Information
            </TabsTrigger>
            <TabsTrigger value="details" className={triggerClass}>
              Details
            </TabsTrigger>
            <TabsTrigger value="meaning" className={triggerClass}>
              Meaning
            </TabsTrigger>
            <TabsTrigger value="key-techniques" className={triggerClass}>
              Key Techniques
            </TabsTrigger>
            <TabsTrigger value="pattern" className={triggerClass}>
              Pattern
            </TabsTrigger>
          </ScrollableCurriculumTabStrip>

          <TabsContent value="pattern-information" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Pattern Information</h4>
              <p className="mb-4 text-gray-700">
                Jitae represents the relationship between Earth and the martial artist. This grandmaster-level pattern emphasizes the importance of being
                grounded while reaching for the highest levels of martial arts mastery, symbolizing the connection between Earth&apos;s stability and human
                aspiration.
              </p>
            </div>
          </TabsContent>
          <TabsContent value="details" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Pattern Details</h4>
              <ul className="list-disc space-y-1 pl-5 text-gray-700">
                <li>Number of Movements: 28</li>
                <li>Pattern Diagram: Earth (土)</li>
                <li>Starting Position: Ready Stance (joon-bee)</li>
              </ul>
            </div>
          </TabsContent>
          <TabsContent value="meaning" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Meaning</h4>
              <p className="text-gray-700">
                Jitae means &quot;Earth&quot; or &quot;Foundation of the Earth,&quot; representing how all martial techniques must be rooted in solid fundamentals while
                reaching for advanced expression. The pattern demonstrates the balance between groundedness and aspiration, stability and dynamism.
              </p>
            </div>
          </TabsContent>
          <TabsContent value="key-techniques" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Key Techniques</h4>
              <ul className="list-disc space-y-1 pl-5 text-gray-700">
                <li>Earth-rooted stances</li>
                <li>Gravitational power methods</li>
                <li>Ground force techniques</li>
                <li>Stability-based movements</li>
                <li>Foundation-focused combinations</li>
                <li>Earth-heaven connections</li>
              </ul>
            </div>
          </TabsContent>
          <TabsContent value="pattern" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Movements</h4>
              <JitaeMovesOl />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    );
  }

  return (
    <div className="mt-2 rounded-lg bg-gray-50 p-4">
      <div className="space-y-4">
        <div>
          {hasDemo?.(["jitae"]) && (
            <button
              type="button"
              className="mb-3 inline-flex items-center text-sm font-medium text-taekwondo-blue hover:underline"
              onClick={() => onWatchDemo?.(["jitae"])}
            >
              Watch Demonstration Video
            </button>
          )}
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Pattern Information</h4>
          <p className="mb-4 text-gray-700">
            Jitae represents the relationship between Earth and the martial artist. This grandmaster-level pattern emphasizes the importance of being
            grounded while reaching for the highest levels of martial arts mastery, symbolizing the connection between Earth&apos;s stability and human
            aspiration.
          </p>
        </div>

        <div>
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Meaning</h4>
          <p className="text-gray-700">
            Jitae means &quot;Earth&quot; or &quot;Foundation of the Earth,&quot; representing how all martial techniques must be rooted in solid fundamentals while
            reaching for advanced expression. The pattern demonstrates the balance between groundedness and aspiration, stability and dynamism.
          </p>
        </div>

        <div>
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Key Techniques</h4>
          <ul className="list-inside list-disc space-y-1 text-gray-700">
            <li>Earth-rooted stances</li>
            <li>Gravitational power methods</li>
            <li>Ground force techniques</li>
            <li>Stability-based movements</li>
            <li>Foundation-focused combinations</li>
            <li>Earth-heaven connections</li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Training Focus</h4>
          <ul className="list-inside list-disc space-y-1 text-gray-700">
            <li>Grounding principles</li>
            <li>Earth energy cultivation</li>
            <li>Foundational mastery</li>
            <li>Balance development</li>
            <li>Power generation</li>
            <li>Spiritual connection</li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Movements</h4>
          <JitaeMovesOl />
        </div>
      </div>
    </div>
  );
}
